import * as React from "react";
import "./pricing.css";
import Typography from "@mui/material/Typography";
import PageBanner from '../../../../common/components/PageBanner';
import { Grid, Button, Modal, Alert, Divider } from "@mui/material";
import { Box } from "@mui/material";
import { pricingSubscription } from "../redux/actions";

import { useState } from "react";

import PricingIntroColumn from "./PricingIntroColumn";
import PlanSelectionCard from "./PlanSelectionCard";
import { PRICING } from "../data/pricingContent";
import PremiumFeaturesColumn from "./PremiumFeaturesColumn";


const Pricing = () => {
  const [open, setOpen] = useState(false);
  const [plan, setPlan] = useState();
  const [billing, setBilling] = useState('monthly');


  const handleClose = () => {
    setOpen(false);
  };

  const handleopen = () => {
    setOpen(true);
  };


  const RenderPopup = (props) => {
    const { onClose, onopen, planvalue, billing } = props
    const isAnnual = billing === 'annual'
    const [formData, setFormData] = useState({
      firstName: '',
      lastName: "",
      emailId: '',
      contactNo: "",
      plan: planvalue
    });
    const currentURL = new URL(window.location.href);
    const pathname = currentURL?.pathname;

    const [isWalmart, setIsWalmart] = useState(pathname === "/walmart")
    const [nameError, setNameError] = useState("");
    const [lastnameError, setLastNameError] = useState("");
    const [numError, setNumError] = useState("");
    const [emailError, setEmailError] = useState("");
    const [couponError, setCouponError] = useState(false)
    const [successMessage, setSuccessMessage] = useState("");
    const [errorMessage, setErrorMessage] = useState("");

    const validateName = (name) => {
      const nameRegex = /^[a-zA-Z\s']+$/;
      return nameRegex.test(name);
    };



    const validateNum = (num) => {
      const phonePattern = /^\d{10}$/;
      return phonePattern.test(num);
    };

    const validateEmail = (email) => {
      const reg = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
      return reg.test(email);
    };


    const handleSubmit = (event) => {
      event.preventDefault();

      const isNameValid = validateName(formData.firstName);
      const isLastNameValid = validateName(formData.lastName);
      const isNumValid = validateNum(formData.contactNo);
      const isEmailValid = validateEmail(formData.emailId);
      const couponCode = formData.couponCode?.trim(); 
      const isValidCoupon = couponCode?.length > 0 ? couponCode === "WALMARTMRF-60OFF" : true;

      if (!isNameValid && !isEmailValid && !isNumValid && !isLastNameValid) {
        setNameError('Please enter a valid Firstname.');
        setLastNameError('Please enter a valid Lastname.');
        setNumError('Please enter a valid Number (10 digits).');
        setEmailError('Please enter a valid email address.');
        return;
      }
      else if (!isNameValid) {
        setNameError('Please enter a valid Firstname.');
        return;
      }
      else if (!isLastNameValid) {
        setLastNameError('Please enter a valid Lastname.');
        return;
      }
      else if (!isNumValid) {
        setNumError('Please enter a valid Number (10 digits).');
        return;
      }

      else if (!isEmailValid) {
        setEmailError('Please enter a valid email address.');
        return;
      }
      else if (!isValidCoupon) { // Check if the coupon code is invalid
        setCouponError('Please enter a valid coupon code.'); // Set the error message for coupon code
        return;
      }
      if(isWalmart){
        formData.page = "Walmart - Pricing"
      } else {
         formData.page = "";
      }
      setNameError('');
      setLastNameError('');
      setNumError('');
      setEmailError('');
      setCouponError('')
      pricingSubscription(formData)
        .then((apiData) => {
          if (apiData && apiData.status === 200) {
            setErrorMessage('');
            setSuccessMessage((isWalmart && isValidCoupon && couponCode?.length > 0) ? 
              "Thank you for subscribing to MYREDFOLDER. Your discount coupon has been applied. Our payments team will get in touch with you shortly to complete the subscription process." 
              : 
              'Thank you for registering your interest in MYREDFOLDER subscription. Our payments team will reach out to you within two business days to complete your subscription.');
            setTimeout(() => {
              setSuccessMessage('');
              handleClose();
            }, 5000);
            event.target.reset();
          }
          if (apiData && apiData.status !== 200) {
            setSuccessMessage('')
            setErrorMessage('');
            setErrorMessage(apiData.message);
          }
        })
        .catch((error) => {
          console.error('Error fetching data:', error);
        });

      // setTimeout(() => {
      //   setSuccessMessage("")
      //   handleClose()
      // }, 5000);
      // console.log(formData);

      // event.target.reset();
    };

    const handleChange = (event) => {
      const { name, value } = event.target;
      if (name === 'firstName') {
        setNameError('')
      }
      else if (name === 'lastName') {
        setLastNameError('')
      }
      else if (name === 'contactNo') {
        setNumError('')
      }
      else if (name === 'emailId') {
        setEmailError('')
      }
      setFormData((prevFormData) => ({ ...prevFormData, [name]: value }));
    };

    const style = {
      position: 'absolute',
      top: '50%',
      left: '50%',
      transform: 'translate(-50%, -50%)',
      width: 600,
      height: 630,
      bgcolor: 'background.paper',
      border: "none",
      borderRadius: "5px",
      p: 2,
    };
    const styleone = {
      position: 'absolute',
      top: '50%',
      left: '50%',
      transform: 'translate(-50%, -50%)',
      width: 600,

      bgcolor: 'background.paper',
      border: "none",
      borderRadius: "5px",
      p: 1,
    };
    return <>
      <Modal
        open={onopen} onClose={onClose}
        aria-labelledby="modal-modal-title"
        aria-describedby="modal-modal-description"
        style={{ zIndex: 10000 }} >

        <Box >
          {successMessage ? (
            <Box className="pricing-form-alert-popup">
              <Alert variant="filled" severity="success">
                {successMessage}
              </Alert>
            </Box>
          ) : errorMessage ? (
            <Box className="pricing-form-alert-popup">
              <Alert variant="filled" severity="error">
                {errorMessage}
              </Alert>
            </Box>
          ) :
            <Box className="pricing-form-popup mrf-pform" role="dialog" aria-modal="true" aria-label="Subscribe">
              <Box>
                <Box>
                  <button type="button" className="mrf-modal__close" aria-label="Close" onClick={handleClose}>&times;</button>
                  <Box >
                    <Typography sx={{ textAlign: "left", ml: "14px !important" }} className="primary-font-bold14"> Subscribe</Typography>
                  </Box>
                </Box>
                <Divider sx={{ height: "2px", mt: "10px" }} />
                <Typography className='primary-font-normal-7' sx={{ paddingY: "20px", ml: "14px" }}>  To subscribe to MYREDFOLDER® {planvalue}, please enter your details here. We
                  will contact you for updates. </Typography>
                {/* TODO(refresh): the live enrollment screen must also show when billing starts and how to cancel, once confirmed. */}
                <Typography className='primary-font-normal-7' sx={{ pb: "16px", ml: "14px" }}>
                  <b>{isAnnual ? `$${PRICING.annual} per year` : `$${PRICING.monthly} per month`}</b>, renewing {isAnnual ? 'each year' : 'each month'}. You won't be charged by submitting this form.
                </Typography>
              </Box>
              <Box className='mobile-pricing-popup-content'>

                <form onSubmit={handleSubmit}>
                  <Box className="pricing-popup-fields">
                    <Typography className='font-normal-small error-message'>{nameError}</Typography>
                    <label style={{ marginLeft: "14px" }} className="primary-font-normal-7">
                      First Name<span className="required-asterisk">*</span>
                    </label>
                    <input
                      type="text"
                      name="firstName"
                      // placeholder="(Required Field)"
                      className={`formStyles ${nameError !== '' ? 'err-input' : ''}`}
                      onChange={handleChange}
                    />
                    <Typography className='font-normal-small error-message'>{lastnameError}</Typography>
                    <label style={{ marginLeft: "14px" }} className="primary-font-normal-7">
                      Last Name<span className="required-asterisk">*</span>
                    </label>
                    <input
                      type="text"
                      name="lastName"
                      // placeholder="(Required Field)"
                      className={`formStyles ${lastnameError !== '' ? 'err-input' : ''}`}
                      onChange={handleChange}
                    />
                    <Typography className='font-normal-small error-message'>{numError}</Typography>
                    <label style={{ marginLeft: "14px" }} className="primary-font-normal-7">
                      Contact Number<span className="required-asterisk">*</span>
                    </label>
                    <input
                      type="text"
                      maxLength={10}
                      name="contactNo"
                      // placeholder="(Required Field)"
                      className={`formStyles ${numError !== '' ? 'err-input' : ''}`}
                      onChange={handleChange}
                    />



                    <div>
                      <Typography className='font-normal-small error-message'>{emailError}</Typography>
                      <label style={{ marginLeft: "14px" }} className="primary-font-normal-7">
                        Email Address<span className="required-asterisk">*</span>
                      </label>
                      <input
                        type="text"
                        name="emailId"
                        // placeholder="(Required Field)"
                        className={`formStyles ${emailError !== '' ? 'err-input' : ''}`}
                        onChange={handleChange}
                      />
                    </div>
                    {isWalmart && (
                      <>
                      <Typography className='font-normal-small error-message'>{couponError}</Typography>
                      <label style={{ marginLeft: "14px" }} className="primary-font-normal-7">
                      Coupon Code<span className="required-asterisk">*</span>
                      </label>
                      <input
                        type="text"
                        name="couponCode"
                        className={`formStyles`}
                        onChange={handleChange}
                      />
                      </>
                    )}
                  </Box>
                  <Box className="pricing-popup-actions">
                    <button type="button" className="mrf-btn mrf-btn--secondary" onClick={handleClose}>Cancel</button>
                    <button type="submit" className="mrf-btn mrf-btn--primary">Submit</button>
                  </Box>

                </form>

              </Box>



              <Box className='laptop-pricing-popup-content' >

                <form onSubmit={handleSubmit}>
                <Box className="pricing-popup-fields">
                  <Typography className='font-normal-small error-message'>{nameError}</Typography>
                  <label style={{ marginLeft: "14px" }} className="primary-font-normal-7">
                    First Name<span className="required-asterisk">*</span>
                  </label>
                  <input
                    type="text"
                    name="firstName"
                    // placeholder="(Required Field)"
                    className={`formStyles ${nameError !== '' ? 'err-input' : ''}`}
                    onChange={handleChange}
                  />
                  <Typography className='font-normal-small error-message'>{lastnameError}</Typography>
                  <label style={{ marginLeft: "14px" }} className="primary-font-normal-7">
                    Last Name<span className="required-asterisk">*</span>
                  </label>
                  <input
                    type="text"
                    name="lastName"
                    // placeholder="(Required Field)"
                    className={`formStyles ${lastnameError !== '' ? 'err-input' : ''}`}
                    onChange={handleChange}
                  />
                  <Typography className='font-normal-small error-message'>{numError}</Typography>
                  <label style={{ marginLeft: "14px" }} className="primary-font-normal-7">
                    Contact Number<span className="required-asterisk">*</span>
                  </label>
                  <input
                    type="text"
                    maxLength={10}
                    name="contactNo"
                    // placeholder="(Required Field)"
                    className={`formStyles ${numError !== '' ? 'err-input' : ''}`}
                    onChange={handleChange}
                  />



                  <div>
                    <Typography className='font-normal-small error-message'>{emailError}</Typography>
                    <label style={{ marginLeft: "14px" }} className="primary-font-normal-7">
                      Email Address<span className="required-asterisk">*</span>
                    </label>
                    <input
                      type="text"
                      name="emailId"
                      // placeholder="(Required Field)"
                      className={`formStyles ${emailError !== '' ? 'err-input' : ''}`}
                      onChange={handleChange}
                    />
                  </div>
                  {isWalmart && (
                      <>
                        <Typography className='font-normal-small error-message'>{couponError}</Typography>
                        <label style={{ marginLeft: "14px" }} className="primary-font-normal-7">
                          Coupon Code
                        </label>
                        <input
                          type="text"
                          name="couponCode"
                          className={`formStyles`}
                          onChange={handleChange}
                        />
                    </>
                  )}
                    </Box>

                  <Box className="pricing-popup-actions">
                    <button type="button" className="mrf-btn mrf-btn--secondary" onClick={handleClose}>Cancel</button>
                    <button type="submit" className="mrf-btn mrf-btn--primary">Submit</button>
                  </Box>
                </form>
              </Box>
            </Box>}
        </Box>
      </Modal>
    </>
  }


  return (
    <Grid container sx={{ marginBottom: "50px" }}>
      <PageBanner eyebrow="Premium membership" title="Pricing" />

      <div className="pricing-container">
        <Grid item xs={12} md={12} sx={{ background: "#FFFFFF" }}>

          <Box className="heading-text" sx={{ marginX: "auto" }}>
            <Typography className="primary-font-bold-heading" sx={{ textAlign: "center" }}>
              Unlock the Full value of MYREDFOLDER® Premium
            </Typography>
          </Box>
          <Box
            sx={{
              display: 'grid',
              gridTemplateColumns: { xs: '1fr', md: '1fr', lg: 'repeat(3, 1fr)' },
              gap: { xs: 2.5, md: 2.5, lg: 3 },
              alignItems: 'stretch',
              mt: 3,
            }}
          >
            <PricingIntroColumn />
            <PlanSelectionCard onSubscribe={(selectedPlan, cycle) => { setPlan(selectedPlan); setBilling(cycle); handleopen(); }} />
            <PremiumFeaturesColumn />
          </Box>
          <RenderPopup onClose={handleClose} onopen={open} planvalue={plan} billing={billing} />

        </Grid>
      </div>
    </Grid>
  );
};


export default Pricing;